(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Chrome iOS reveals its toolbar at the bottom of the page, which resizes the
      // viewport and fires spurious scroll events. Suppress header toggling briefly
      // after any viewport resize so the header and mobile dock don't flicker.
      this.onResizeHandler = () => { this.suppressScrollUntil = performance.now() + 300; };
      window.addEventListener('resize', this.onResizeHandler, false);
      window.visualViewport?.addEventListener('resize', this.onResizeHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.visualViewport?.removeEventListener('resize', this.onResizeHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // Chrome's toolbar resizes the viewport at the page extremes, firing scroll events
      // that aren't real user scrolls. If innerHeight changed since the last event, treat
      // this scroll as a resize artifact: update position but don't toggle the bars.
      if (window.innerHeight !== this.lastInnerHeight) {
        this.lastInnerHeight = window.innerHeight;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      // Ignore tiny scroll deltas (rubber-band / toolbar settle jitter) that would
      // otherwise register as a direction change and flicker the header.
      if (Math.abs(scrollTop - this.currentScrollTop) < 5) return;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-social-strip"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sb-social-strip')) {
  customElements.define('sb-social-strip', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sbss__track');
      this.prev = this.querySelector('.sbss__arrow--prev');
      this.next = this.querySelector('.sbss__arrow--next');
      this.dialog = this.querySelector('.sbss-viewer');
      this.video = this.querySelector('.sbss-viewer__video');
      this.img = this.querySelector('.sbss-viewer__img');
      this.bar = this.querySelector('.sbss-viewer__bar span');
      this.creator = this.querySelector('.sbss-viewer__creator');
      this.sound = this.querySelector('.sbss-viewer__sound');
      this.steps = this.querySelectorAll('.sbss-viewer__step');
      this.items = null; this.i = 0;

      // Movement copies Instafeed's slider: the row is slid with a CSS transform (0.5s ease-in-out), one card per
      // arrow press or swipe, looping at both ends. A swipe never follows the finger: once it passes 50px sideways it
      // fires once and the rest of that gesture is ignored. Half cards show only on load.
      const vp = this.querySelector('.sbss__viewport'), t = this.track;
      const step = () => { const c = t.querySelectorAll('.sbss__item'); return c.length > 1 ? c[1].offsetLeft - c[0].offsetLeft : 200; };
      const maxPos = () => Math.max(0, t.scrollWidth - vp.clientWidth);
      this.pos = 0;
      const setPos = (x, animate) => {
        this.pos = x; t.dataset.pos = Math.round(x);
        if (!animate) { t.style.transition = 'none'; t.style.transform = 'translate3d(' + (-x) + 'px,0,0)'; t.offsetHeight; t.style.transition = ''; return; }
        this.moving = true; t.style.transform = 'translate3d(' + (-x) + 'px,0,0)';
        clearTimeout(this.moveTimer); this.moveTimer = setTimeout(() => { this.moving = false; }, 520);
      };
      const page = dir => {
        if (this.moving) return;
        const st = step(), max = maxPos(), cur = this.pos;
        if (dir < 0 && cur <= 4) return setPos(max, true);
        if (dir > 0 && cur >= max - 4) return setPos(0, true);
        const k = dir > 0 ? Math.floor(cur / st + 0.01) + 1 : Math.ceil(cur / st - 0.01) - 1;
        setPos(Math.max(0, Math.min(max, k * st)), true);
      };
      this.prev.addEventListener('click', () => page(-1));
      this.next.addEventListener('click', () => page(1));

      let sx = 0, sy = 0, axis = null, fired = false;
      vp.addEventListener('touchstart', e => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; axis = null; fired = false; }, { passive: true });
      vp.addEventListener('touchmove', e => {
        const x = e.touches[0].clientX - sx, y = e.touches[0].clientY - sy;
        if (!axis && (Math.abs(x) > 10 || Math.abs(y) > 10)) axis = Math.abs(x) > Math.abs(y) ? 'x' : 'y';
        if (axis === 'x' && !fired && Math.abs(x) > 50) { fired = true; this.dragged = true; page(x < 0 ? 1 : -1); }
      }, { passive: true });
      vp.addEventListener('touchend', () => { if (axis === 'x') setTimeout(() => { this.dragged = false; }, 350); });
      let mx = null, mFired = false;
      vp.addEventListener('pointerdown', e => { if (e.pointerType === 'mouse' && e.button === 0) { mx = e.clientX; mFired = false; } });
      window.addEventListener('pointerup', () => { if (mx !== null) { mx = null; if (mFired) setTimeout(() => { this.dragged = false; }, 50); } });
      vp.addEventListener('pointermove', e => {
        if (mx === null || mFired || Math.abs(e.clientX - mx) <= 50) return;
        mFired = true; this.dragged = true; page(e.clientX < mx ? 1 : -1);
      });
      vp.addEventListener('dragstart', e => e.preventDefault());
      let wheelAt = 0;
      vp.addEventListener('wheel', e => {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || Math.abs(e.deltaX) < 8) return;
        e.preventDefault(); const now = Date.now(), fresh = now - wheelAt > 250; wheelAt = now;
        if (fresh) page(e.deltaX > 0 ? 1 : -1);
      }, { passive: false });

      this.updateArrows = () => { const more = maxPos() > 4; this.prev.hidden = !more; this.next.hidden = !more; };
      new ResizeObserver(() => { this.updateArrows(); if (this.pos > maxPos()) setPos(maxPos(), false); }).observe(vp);
      if (this.hasAttribute('data-half-start') && maxPos() > 0) setPos(step() / 2, false);
      // Previews download straight after the page has finished loading (out of the way of the first load, and before
      // the shopper scrolls down to How Orbie Works), or immediately if they scroll within 200px of the strip first.
      const loadPosters = () => this.querySelectorAll('img[data-src]').forEach(i => { i.srcset = i.dataset.srcset; i.src = i.dataset.src; i.removeAttribute('data-src'); });
      const watch = margin => { const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); loadPosters(); } }, { rootMargin: margin + ' 0px' }); io.observe(this); };
      watch('200px');
      const afterLoad = () => setTimeout(loadPosters, 300);
      if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad, { once: true });
      this.updateArrows();

      this.track.addEventListener('click', e => {
        const b = e.target.closest('.sbss__card'); if (!b || this.dragged) return;
        this.open(+b.dataset.index, b);
      });
      this.querySelector('.sbss-viewer__close').addEventListener('click', () => this.close());
      this.dialog.addEventListener('cancel', e => { e.preventDefault(); this.close(true); });
      this.steps.forEach(s => s.addEventListener('click', () => this.go(this.i + +s.dataset.step)));
      this.dialog.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); this.go(this.i + 1); }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.i - 1); }
      });
      this.video.addEventListener('click', () => this.video.paused ? this.video.play() : this.video.pause());
      ['playing', 'loadeddata'].forEach(ev => this.video.addEventListener(ev, () => this.video.classList.add('is-ready')));
      this.video.addEventListener('timeupdate', () => { if (this.video.duration) this.bar.style.width = (100 * this.video.currentTime / this.video.duration) + '%'; });
      this.video.addEventListener('ended', () => { if (this.i < this.items.length - 1) this.go(this.i + 1); else { this.video.currentTime = 0; this.video.play(); } });
      this.sound.addEventListener('click', () => this.setMuted(!this.video.muted));

      let y0 = null, x0 = null;
      const stage = this.querySelector('.sbss-viewer__stage');
      stage.addEventListener('touchstart', e => { y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', e => {
        if (y0 === null) return;
        const dy = e.changedTouches[0].clientY - y0, dx = e.changedTouches[0].clientX - x0; y0 = null;
        if (Math.abs(dy) > 50 && Math.abs(dy) > Math.abs(dx)) this.go(this.i + (dy < 0 ? 1 : -1));
        else if (Math.abs(dx) < 10 && Math.abs(dy) < 10 && this.items[this.i].type === 'video') this.video.paused ? this.video.play() : this.video.pause();
      });
    }
    data() {
      if (!this.items) { try { this.items = JSON.parse(this.querySelector('.sbss__data').textContent); } catch (e) { this.items = []; } }
      return this.items;
    }
    open(i, from) {
      this.data(); this.from = from;
      document.documentElement.classList.add('sbss-lock');
      this.dialog.showModal();
      this.muted = true;
      this.go(i);
    }
    setMuted(m) {
      this.muted = m; this.video.muted = m;
      this.sound.classList.toggle('is-on', !m);
      this.sound.setAttribute('aria-label', m ? 'Turn sound on' : 'Turn sound off');
    }
    go(i) {
      const items = this.items;
      if (i < 0 || i >= items.length) return;
      this.i = i;
      const it = items[i];
      this.video.pause(); this.bar.style.width = '0';
      this.steps[0].disabled = i === 0; this.steps[1].disabled = i === items.length - 1;
      const where = it.platform === 'TikTok' ? 'TikTok' : 'Instagram';
      this.creator.innerHTML = '';
      if (it.creator) this.creator.append('@' + it.creator);
      if (it.url) { const s = document.createElement('span'); s.textContent = (it.creator ? ' · ' : '') + 'View on ' + where; this.creator.append(s); this.creator.href = it.url; }
      else this.creator.removeAttribute('href');
      if (it.type === 'video') {
        this.img.hidden = true; this.video.hidden = false; this.sound.hidden = false;
        const src = (window.innerWidth > 700 || (navigator.connection && navigator.connection.effectiveType === '4g')) ? (it.large || it.small) : (it.small || it.large);
        this.video.removeAttribute('poster'); this.video.classList.remove('is-ready');
        this.video.src = src; this.video.muted = this.muted;
        this.sound.classList.toggle('is-on', !this.muted);
        const p = this.video.play();
        if (p) p.catch(() => { this.setMuted(true); this.video.play().catch(() => {}); });
      } else {
        this.video.removeAttribute('src'); this.video.load(); this.video.hidden = true; this.sound.hidden = true;
        this.img.src = it.poster; this.img.hidden = false;
      }
      const nx = items[i + 1]; if (nx && nx.poster) { const pre = new Image(); pre.src = nx.poster; }
    }
    close(byKey) {
      this.video.pause(); this.video.removeAttribute('src'); this.video.load();
      this.dialog.close();
      document.documentElement.classList.remove('sbss-lock');
      if (byKey && this.from) this.from.focus({ preventScroll: true });
      else if (document.activeElement) document.activeElement.blur();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-shop-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    var bars=document.querySelectorAll('.sticky-shop-bar');
    for(var b=0;b<bars.length;b++){
      var bar=bars[b];
      if(bar.dataset.ssbInit)continue;
      bar.dataset.ssbInit='1';
      (function(bar){
        var triggerText=(bar.getAttribute('data-trigger')||'').trim().toLowerCase();
        var appearOffset=parseInt(bar.getAttribute('data-appear')||'0',10)||0;
        var target=null;
        if(triggerText){
          var hs=document.querySelectorAll('h1,h2,h3,h4');
          for(var i=0;i<hs.length;i++){
            if(hs[i].textContent.replace(/\s+/g,' ').trim().toLowerCase().indexOf(triggerText)!==-1){target=hs[i].closest('.shopify-section')||hs[i];break;}
          }
        }
        var ticking=false;
        function update(){
          ticking=false;
          var vh=window.innerHeight,y=window.pageYOffset||document.documentElement.scrollTop;
          var show=target?(target.getBoundingClientRect().top<=(0-appearOffset)):(y>vh*1.2);
          bar.classList.toggle('is-visible',show);
          document.body.classList.toggle('ssb-on',show);
        }
        function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(update);}}
        window.addEventListener('scroll',onScroll,{passive:true});
        window.addEventListener('resize',onScroll,{passive:true});
        update();
      })(bar);
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-collage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var phone = window.matchMedia('(max-width: 749px)');
    function wire(card) {
      if (card.dataset.lazyWired) return;
      card.dataset.lazyWired = '1';
      var v = card.querySelector('video[data-src-lg]');
      if (!v) {
        new MutationObserver(function () {
          var other = card.querySelector('video');
          if (other && card.classList.contains('is-active')) { other.play().catch(function () {}); }
        }).observe(card, { attributes: true, attributeFilter: ['class'] });
        return;
      }
      var onScreen = false, tried = [];
      function start() {
        if (v.getAttribute('src')) return;
        v.addEventListener('error', function () {
          tried.push(v.getAttribute('src'));
          var next = [v.dataset.srcLg, v.dataset.srcFb].filter(function (u) { return u && tried.indexOf(u) < 0; })[0];
          if (next) { v.src = next; sync(); }
        });
        v.src = phone.matches ? v.dataset.srcSm : v.dataset.srcLg;
      }
      function sync() {
        if (onScreen && card.classList.contains('is-active')) {
          start();
          var p = v.play(); if (p) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      }
      v.sbStart = start;
      new IntersectionObserver(function (entries) {
        onScreen = entries[entries.length - 1].isIntersecting;
        sync();
      }, { rootMargin: '200px 0px' }).observe(card);
      new MutationObserver(sync).observe(card, { attributes: true, attributeFilter: ['class'] });
    }
    function warm(collage) {
      var first = collage.querySelector('.tab-collage__card video[data-src-lg]');
      if (!first || !first.sbStart) return;
      new IntersectionObserver(function (entries, io) {
        if (entries[entries.length - 1].isIntersecting) { first.preload = 'auto'; first.sbStart(); io.disconnect(); }
      }, { rootMargin: '800px 0px' }).observe(collage);
    }
    function wireAll(root) {
      root.querySelectorAll('.tab-collage__card').forEach(wire);
      root.querySelectorAll('tab-collage').forEach(warm);
    }
    wireAll(document);
    document.addEventListener('shopify:section:load', function (e) { wireAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
